import { VpnIcon } from './VpnIcon';

/**
 * author: Austin Andrews
 * id A9EE1532-2932-4F71-95DC-1EFB56BA4DFC
 * name vpn
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/vpn.svg
 * tags
 */
export const VirtualPrivateNetworkIcon = VpnIcon;
export default VirtualPrivateNetworkIcon